import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getTranslation } from '@shared/translate-helper';

@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  standalone: false,
})
export class TimeoutComponent {
  public errorCode: string = '408';
  public errorTitle!: string;
  public errorDescription!: string;
  public quickTip!: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    getTranslation(this.translateService, ['408_title', '408_description', '408_quick_tip']).subscribe((t) => {
      this.errorTitle = t['408_title'];
      this.errorDescription = t['408_description'];
      this.quickTip = t['408_quick_tip'];
    });
  }
}
